// removed by extract-text-webpack-plugin
module.exports = {"spinner":"spinner__spinner___1zgDO","bar":"spinner__bar___1OfgH","spinner-wave":"spinner__spinner-wave___11oW4","first":"spinner__first___1uTjY spinner__bar___1OfgH","second":"spinner__second___vftQH spinner__bar___1OfgH","third":"spinner__third___2UxYl spinner__bar___1OfgH"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/spinner/spinner.css
// module id = ./src/ui/spinner/spinner.css
// module chunks = 0